import { IconButton } from '@material-ui/core';
import React from 'react';

import { EnvHeader } from '../../common/env-header';
import { useAgent } from '../../hooks/use-agent';
import { usePageDialog } from '../../hooks/use-page-dialog';
import { OrbitButton } from '../orbit-button';

export const AgentResultsHeader: React.FC<{
    title: string;
    actions?: React.ReactNode;
}> = ({ title, actions }) => {
    const dialog = usePageDialog();
    const agent = useAgent();

    React.useEffect(() => {
        // Close orbit dialog if open, to render the results dialog unhindered
        agent.onClose();
        return () => {
            // on unmount, re-open the orbit dialog if it was previously open
            agent.onOpen();
        };
    }, []);

    const handleClose = () => dialog.onClose();

    return (
        <div className="flex-fixed" id="page-header">
            <EnvHeader />
            <div className="page-header-primary">
                <div className="header-left">
                    <div className="header-left-menu">
                        <IconButton onClick={handleClose}>
                            <i className="material-icons">close</i>
                        </IconButton>
                    </div>
                    <div className="header-title">{title}</div>
                </div>
                <div className="header-right" style={{ marginRight: '20px' }}>
                    {actions}
                    <div style={{ marginLeft: '20px' }}>
                        <OrbitButton />
                    </div>
                </div>
            </div>
        </div>
    );
};
